<template>
    <td-dialog :title="$t(title)" :before-close="personnelDialogClose" :visible.sync="dialogPersonnelVisible" width="850px" :close-on-click-modal="false" :close-on-press-escape="false" top="18vh">
        <el-form :inline="true" :model="fromPost" ref="fromPost" class="demo-form-inline" :rules="rules" @submit.native.prevent >
            <el-row :gutter="20" style="margin-top:5px;">
                <el-col>
                    <span style="font-size:16px;font-weight;"> {{ $t('pgCommon.CURRENT_DEP') }} : {{ structureItem.caption }}</span>
                </el-col>
                <el-col>
                    <el-form-item :label="$t('pgCommon.PERSON_NAME')">
                        <td-input v-model="staffCaption"> </td-input>
                    </el-form-item>
                    <el-form-item class="paddingLeft10">
                        <td-button type="primary" :permissions="permissionsEdit" @click="btnQuery">{{ $t('pgCommon.QUERY') }}</td-button>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <td-permission :permissions="permissionsView" style="width:100%;margin-bottom:10px;">
            <div slot="havePermission">
                <td-table
                    height="540px"
                    :columns="columns"
                    rowKey="sId"
                    :currentPage="currentPage"
                    :hasMutiSelect="true"
                    :dataSource="tableData"
                    :pageSize="pageSize"
                    :total="total"
                    :hasLoading="loadings"
                    ref="personnel"
                    @cell-click="clicktree"
                    @handleSizeChange="handleSizeChange"
                    @currentChange="currentChange"
                >
                </td-table>
            </div>
        </td-permission>
        <span slot="footer">
            <td-button type="primary" :loading="addLoading" @click="submitForm('formOrgInfo')">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import staffApi from './../assets/api.js';
import HashMap from 'hashmap';
export default {
    props: ['title', 'dialogPersonnelVisible', 'editItem', 'structureItem', 'demovalue'],
    created() {
        // 初始化控件
        this.checkedMap = new HashMap();
        this.btnQuery();
    },
    // 定义变量
    data() {
        return {
            //所属设备-组织设备树使用--开始----
            interfaceName: { query: '/device/queryDeviceOrgTree', search: '/device/queryDeviceOrgTreeByName' },
            selectModule: [], // 下拉框数据
            deviceProps: {
                children: 'children',
                label: 'caption',
                id: 'id',
                imgName: 'sIcon',
                parentId: 'parentId'
            },
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            staffCaption: '',
            params: {
                includeSelf: true, // 查询条件是否包含自己
                parentId: '',
                rootCodes: this.$common.initOrgTreeParam.SCODE,
                orgTypeIds: this.$common.initOrgTreeParam.ORGTYPEIDS,
                deviceTypeList: this.parentDevType
            },
            columns: [
                {
                    prop: 'sName',
                    label: this.$t('pgCommon.PERSON_NAME')
                },
                // {
                //     prop: '',
                //     label: this.$t('pgCommon.MAIN_DEP'),
                //     tableWidth: '80',
                //     align: 'center',
                //     render: (createElement, params) => {
                //         let checkStatus = false;
                //         let _this = this;
                //         if (this.checkedMap.has(params.row.sTableName)) {
                //             checkStatus = true;
                //         }
                //         return createElement('div', [
                //             createElement('td-checkbox', {
                //                 props: {
                //                     checked: checkStatus
                //                 },
                //                 on: {
                //                     change: val => {
                //                         this.checkBoxChange(params.row, val);
                //                     }
                //                 }
                //             })
                //         ]);
                //     }
                // },
                {
                    prop: '',
                    label: this.$t('pgCommon.POST_STATION'),
                    render: (createElement, params) => {
                        var self = this;
                        return createElement(
                            'div',
                            {
                                style: {
                                    height: '64px',
                                    'text-align': 'center'
                                }
                            },
                            [
                                createElement('td-port-station-select', {
                                    style: {
                                        marginTop: '-20px',
                                        width: '120px;'
                                    },
                                    props: {
                                        requetParam: {
                                            structureIdList: [this.structureItem.id]
                                        }
                                    },
                                    //td-select实现下拉框
                                    on: {
                                        portStationChange: function(data) {
                                            self.selectModule[params.row.sId + '_station'] = data;
                                        }
                                    }
                                })
                            ]
                        );
                    }
                },
                {
                    prop: '',
                    label: this.$t('pgCommon.DIRECT_LEADER'),
                    render: (createElement, params) => {
                        var self = this;
                        return createElement('td-org-structure-tree', {
                            style: {
                                'margin-left': '7px'
                            },
                            props: {
                                editItem: { staffId: params.row.sId }
                            },
                            on: {
                                clickChosen: function(data) {
                                    self.selectModule[params.row.sId + '_lader'] = data.sId;
                                },
                                handleClose: function(data) {
                                    self.selectModule[params.row.sId + '_lader'] = '';
                                }
                            }
                        });
                    }
                }
            ],
            tableData: []
        };
    },
    // 定义并实现方法体
    methods: {
        // 提交数据
        submitForm() {
            this.addLoading = true;
            let items = this.$refs.personnel.getSelectAllRows();
            if (items == null || items.length === 0) {
                this.$message({ showClose: true, message: this.$t('pgCommon.PLEASE_SELECT'), type: 'warning' });
                this.addLoading = false;
                return;
            }
            let staffRelationList = [];
            let alertInfo = '';
            for (let i = 0; i < items.length; i++) {
                let stationField = this.selectModule[items[i].sId + '_station'];
                // if (stationField == null || stationField === '') {
                //     alertInfo += items[i].sName + this.$t('pgCommon.POST_STATION_NOT_SELECT') + this.$t('pgCommon.PROMPT_SEPARATOR');
                // }
                let leader = this.selectModule[items[i].sId + '_lader'];
                let param = {
                    sStaffId: items[i].sId,
                    sDeptId: this.structureItem.id,
                    sDuty: stationField
                };
                if (leader != null && leader != '' && leader != undefined) {
                    param.sLeader = leader;
                }
                staffRelationList.push(param);
            }
            if (alertInfo != '') {
                this.$message({ showClose: true, message: alertInfo.substring(0, alertInfo.length - 2), type: 'warning', duration: '10000' });
                this.addLoading = false;
                return;
            }
            staffApi.addStaffRelationInfo(JSON.stringify(staffRelationList), response => {
                this.addLoading = false;
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('staffApi.addStaffRelationInfo', response);
                    return;
                }
                this.$message({ showClose: true, message: this.$t('pgCommon.ADD_SUCCESS'), type: 'success' });
                this.personnelDialogClose();
                this.$emit('queryList');
                this.query();
            });
        },
        // checkbox控件change时间
        checkBoxChange(item, val) {
            if (val === true) {
                this.$refs.personnel.toggleRowSelection(item, true);
                this.checkedMap.set(item.sId, item);
            } else {
                this.checkedMap.remove(item.sId);
            }
        },
        btnQuery() {
            this.currentPage = 1;
            this.query();
        },
        // 查询未关联数据
        query() {
            this.selectModule = [];
            this.checkedMap.clear();
            let param = {
                sStaffName: this.staffCaption,
                sDeptId: this.structureItem.id,
                pageSize: this.pageSize,
                currentPage: this.currentPage
            };
            staffApi.getUnConfigStaffInfo(JSON.stringify(param), response => {
                this.loading = false;
                if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ type: 'error', showClose: true, message: response.data.statusMessage });
                    this.$log.error('orgApi.updateOrg', response);
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
            });
        },
        // 取消
        cancel() {
            this.personnelDialogClose();
        },
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.query();
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.query();
        },
        // 关闭窗口之前需要调用的方法
        personnelDialogClose() {
            this.$emit('personnelDialogClose');
        }
    }
};
</script>
<style>
.btnStyle {
    text-align: center;
}
.el-dialog__header {
    background-color: #266eb1;
}
.el-dialog__headerbtn .el-dialog__close {
    color: #000 !important;
}
.address-placeholder {
    color: #c0c4cc;
    padding: 10px 15px;
    font-size: 13px;
    font-family: 'Microsoft Yahei', sans-serif;
    position: absolute;
    left: 0;
    top: 0;
}
</style>
